import { render, staticRenderFns } from "./type4510.vue?vue&type=template&id=2f17728b&scoped=true&"
import script from "./type4510.vue?vue&type=script&lang=js&"
export * from "./type4510.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f17728b",
  null
  
)

export default component.exports